import { PaymentRequestType } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { PaymentAmountSection } from '../../../../common/PaymentAmountSection';
import { PaymentCommonSection } from '../../../../common/PaymentCommonSection';
import { PaymentRequestFormReasonField } from './PaymentRequestFormReasonField';
import { PaymentRequestFormExpirationField } from './PaymentRequestFormExpirationField';
import { PaymentRequestFormMessageField } from './PaymentRequestFormMessageField';
import { PaymentRequestFormInternalNoteField } from './PaymentRequestFormInternalNoteField';
import { PaymentRequestFormTitle } from './PaymentRequestFormTitle';
import { PaymentRequestPaymentMethodsField } from './PaymentRequestPaymentMethodsField';
import { PaymentRequestFormEmailField } from './PaymentRequestFormEmailField';

export const CollectPaymentFormFields = ({ accountId }: WithAccountId) => {
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);

    return (
        <>
            <PaymentRequestFormTitle />
            <PaymentCommonSection />
            <PaymentRequestFormReasonField />
            {isPaymentRequestCollectTypeEnabled && (
                <PaymentRequestPaymentMethodsField paymentRequestType={PaymentRequestType.Payment} />
            )}
            <PaymentAmountSection />
            <PaymentRequestFormExpirationField />
            {isPaymentRequestCollectTypeEnabled && <PaymentRequestFormEmailField accountId={accountId} />}
            <PaymentRequestFormMessageField />
            <PaymentRequestFormInternalNoteField />
        </>
    );
};
